import * as React from "react";
import { FilterSelect, } from "@warda/library-ui/core/Filter";
const FilterSimpleSelection = (p) => {
    const { id, label, labelSub, type, value = [], onChange, onClickCount, className, collapsed, collapsedHelp, mandatory, searchable = true, options, maxItems, } = p;
    return (React.createElement(FilterSelect, { id: id, type: type, label: label, labelSub: labelSub, onChange: onChange, searchable: searchable, onClickCount: onClickCount, options: options, value: value.map((v) => v.id), className: className, collapsed: collapsed, collapsedHelp: collapsedHelp, mandatory: mandatory, maxItems: maxItems }));
};
export default FilterSimpleSelection;
